import { Tool, ToolType } from './tool';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { LevelDesignerElementBase } from '../elements/element-base';
import { VisualTool } from './tool-base-types';
import { PassiveTool } from './tool-base-types';
import { ActionTool } from './tool-base-types';
import { PolygonElement } from '../elements/polygon-element';
import { ToolGroup } from './tool-group';

export class ToggleMeasurementsTool extends VisualTool {
    private readonly FONT_SIZE = 14;
    private readonly PADDING = 5;

    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, ToolType.Toggle, 'assets/icons/measurements.svg');
       
    }
    override getTooltip(): string {
        return 'Show/Hide Measurements';
    }

    getName(): string {
        return 'Toggle Measurements';
    }

    override onActivated(): void {
        this.levelDesigner.redraw();
    }

    onClick(x: number, y: number): void {
        // No additional click handling needed
    }

    onKeyPress(key: string): void {
        // No additional key handling needed
    }

    public override getButtonWidth(): number {
        return 40;
    }


    public override render(ctx: CanvasRenderingContext2D): void {
        if (!this.enabled) return;

        const scale = this.levelDesigner.getScale();
        ctx.save();
        
        // Set up text style
        ctx.font = `${this.FONT_SIZE / scale}px Arial`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'black';
        
        // Draw measurements for selected elements
        for (const element of this.levelDesigner.selectedElements) {
            if (element instanceof PolygonElement) {
                this.drawPolygonMeasurements(ctx, element);
            }
        }
        
        ctx.restore();
    }

    private drawPolygonMeasurements(ctx: CanvasRenderingContext2D, polygon: PolygonElement): void {
        const points = polygon.getPoints();
        const scale = this.levelDesigner.getScale();
        const LABEL_OFFSET = 8 / scale; // Distance of label from the line

        for (let i = 0; i < points.length; i++) {
            const p1 = points[i];
            const p2 = points[(i + 1) % points.length];

            // Calculate midpoint and length
            const midX = (p1.x + p2.x) / 2;
            const midY = (p1.y + p2.y) / 2;
            const dx = p2.x - p1.x;
            const dy = p2.y - p1.y;
            const length = Math.sqrt(dx * dx + dy * dy);
            
            // Calculate angle and perpendicular vector for offset
            const angle = Math.atan2(dy, dx);
            const perpX = -Math.sin(angle); // Perpendicular vector
            const perpY = Math.cos(angle);
            
            // Position label outside the line
            const labelX = midX + (perpX * LABEL_OFFSET);
            const labelY = midY + (perpY * LABEL_OFFSET);

            // Calculate display angle (keep text readable)
            let displayAngle = angle;
            if (angle > Math.PI / 2 || angle < -Math.PI / 2) {
                displayAngle += Math.PI;
            }

            // Draw measurement text
            ctx.save();
            ctx.translate(labelX, labelY);
            ctx.rotate(displayAngle);
            
            // Draw background
            const text = `${length.toFixed(2)}m`;
            const textWidth = ctx.measureText(text).width;
            const bgHeight = this.FONT_SIZE / scale;
            const bgWidth = textWidth + (this.PADDING * 2) / scale;
            
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.fillRect(-bgWidth/2, -bgHeight/2, bgWidth, bgHeight);
            
            // Draw text
            ctx.fillStyle = 'black';
            ctx.fillText(text, 0, 0);
            ctx.restore();
        }
    }
}
